export const PROVIDER_DOW_JONES = 'DOW_JONES';
export const PROVIDER_LEXIS_NEXIS = 'LEXIS_NEXIS';
export const PROVIDER_CAPITAL_GROUP = 'CAPITAL_GROUP';
